import { render } from "./DepositSubmission.vue?vue&type=template&id=56825178"
import script from "./DepositSubmission.vue?vue&type=script&lang=js"
export * from "./DepositSubmission.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__